<template>
    <metainfo></metainfo>
  <RouterView />
</template>

<script>
import { reactive, ref, toRefs } from "@vue/reactivity";
import { RouterLink, RouterView } from "vue-router";

// 准备传入子组件中的数据
const source = [];

export default {
  name: "App",
  setup() {
    let data = reactive({
      direction: true,
      timer: null,
      source: source,
      centerindex: -1,
    });


    function previous() {
      console.log(data.source, "调整前面");
      // data.source.push(data.source[data.source.length-1])
      data.source = [
        data.source[data.source.length - 1],
        ...data.source.slice(0, data.source.length - 1),
      ];
      // data.source.splice(1,0,data.source[data.source.length-1],)
      // data.source.pop()
    }
    function nextpage() {
      data.source = [...data.source.slice(1), data.source[0]];
    }
 
    return {
      source,
      data,
      previous,
      nextpage,
    };
  },
};
</script>

<style lang="scss">
</style>
